
import {Navbar,Footer} from '../medicalcomponents'
import React,{useState} from "react";
import * as Icon from "react-bootstrap-icons";
import {Outlet, useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();

  if(localStorage.getItem('branchID')===null){
    window.location.replace('/');
  }
  
    const modules = [
      
        {
          moduleName: "MEDICAL",
          icon: <Icon.CalendarCheck />,
          menus: [
            { name: "Dashboard", icon: <Icon.Speedometer />, path:"medicalDashboard" },
            { name: "Item Entry", icon: <Icon.JournalPlus  />, path:"itementry" },
            { name: "Item Issue", icon: <Icon.Bullseye  />, path:"itemissue" },
            { name: "Item Receive", icon: <Icon.BarChartLineFill  />, path:"itemreceive" },
            
          ],
        },
      
        {
          moduleName: "REPORTS",
          icon: <Icon.GearFill />,
          menus: [
            { name: "Issue Report", icon: <Icon.FileEarmarkText  />, path:"issuereport" },
            { name:"Monthly Issue Register", icon:< Icon.Receipt />, path:"monthlyIssueRegister"},
            { name:"First Moving Items", icon:< Icon.GraphUpArrow  />,path:"firstMovingItems"},
          ],
        },
      ];
      const [activeMenu, setActiveMenu] = useState("Dashboard");
      const [openModule, setOpenModule] = useState("MEDICAL");
    
      const toggleModule = (moduleName) => {
        setOpenModule(openModule === moduleName ? "" : moduleName);
      };

      const [collapsed, setCollapsed] = useState(false);

  return (
    <>
    <div className="container-fluid" >

  <Navbar />

  <div className="d-flex" style={{marginTop:75}}>

    {/* SIDEBAR */}
    <div
      style={{
        minHeight: "100vh",
        background: "#1e293b",
        color: "white",
        width: collapsed ? "70px" : "260px",
        transition: "0.3s",
      }}
    >

      {/* Header */}
      <div className="p-3 d-flex justify-content-between align-items-center border-bottom" style={{ background: "#0f172a" }}>
        {!collapsed && <h5 className="m-0">MEDICAL Mgt.</h5>}

        <button
          onClick={() => setCollapsed(!collapsed)}
          style={{ background: "none", border: "none", color: "white" }}
        >
          {collapsed ? "☰" : "✕"}
        </button>
      </div>

      {/* MENU */}
      <div className="p-2">

        {modules.map((module, index) => (
          <div key={index}>

            <div className="p-2 d-flex align-items-center gap-2" onClick={() => toggleModule(module.moduleName)}
              style={{ 
                cursor: "pointer",
                background:
                openModule === module.moduleName ? "#334155" : "transparent", }}
            >
              {module.icon}
              {!collapsed && module.moduleName}  
            </div>

            {!collapsed && openModule === module.moduleName && (
              <div className="ms-3 mt-2">

                {module.menus.map((menu, i) => (
                  <div
                    key={i}
                    className="p-2 mb-1 rounded d-flex align-items-center gap-2"
                    style={{ cursor: "pointer", background: activeMenu === menu.name ? "#2563eb" : "transparent" }}
                    onClick={() => {
                      setActiveMenu(menu.name);
                      navigate(menu.path);
                    }}
                    
                  >
                    {menu.icon} <span>{menu.name}</span>
                  </div>
                ))}

              </div>
            )}

          </div>
        ))}

      </div>

    </div>

    {/* MAIN BODY */}
    <div style={{ flex: 1, minHeight: "100vh" }}>
      <Outlet />
    </div>

  </div>

  <Footer />

</div>

    </>
  )
}

export default Home